import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1 class=\"anchor fw-bolder mb-5\" id=\"sizes\"><a href=\"#sizes\"></a> Sizes </h1><div class=\"py-5\"> Use <code>.separator</code> class in combination with <a href=\"https://getbootstrap.com/docs/5.0/utilities/borders/#border-width\" class=\"fw-bold\">Bootstrap Border Width</a>  classes to change separator border width: </div><div class=\"py-5\"><div class=\"rounded border p-10\"><div class=\"separator my-10\"></div><div class=\"separator border-2 my-10\"></div><div class=\"separator border-3 my-10\"></div><div class=\"separator border-4 my-10\"></div><div class=\"separator border-5 my-10\"></div></div></div>", 3)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="separator my-10"></div>
        <div class="separator border-2 my-10"></div>
        <div class="separator border-3 my-10"></div>
        <div class="separator border-4 my-10"></div>
        <div class="separator border-5 my-10"></div>
        `))
        ]),
        _: 1
      })
    ])
  ]))
}